import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Heart } from 'lucide-react';
import MarketingLayout from '../components/marketing/MarketingLayout';
import PageHero from '../components/marketing/PageHero';
import { IMAGES } from '../lib/marketingImages';
import { usePublicUserCount } from '../lib/usePublicUserCount';

export default function AboutPage() {
  const navigate = useNavigate();
  const userCount = usePublicUserCount();
  return (
    <MarketingLayout>
      <PageHero
        image={IMAGES.community}
        eyebrow="About SmartPay"
        title="A bill app that feels like a neighbour, not a corporation."
        subtitle="We built SmartPay for Malawian households who are tired of queues, missed reminders, and lights going out at the worst moment."
      />
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
        <img src={IMAGES.family} alt="People collaborating" className="rounded-3xl w-full h-[380px] object-cover shadow-xl" />
        <div>
          <h2 className="text-3xl font-extrabold mb-4">Why we exist</h2>
          <p className="text-muted-foreground text-lg mb-6">
            Paying for electricity, water, and TV should take less time than boiling water. We started SmartPay so families can stay connected without giving up a Saturday morning at the kiosk.
          </p>
          <ul className="space-y-3">
            {[
              'Local providers: ESCOM, water boards, DStv, GOtv',
              'Customer support that answers on WhatsApp',
              'Receipts and saved meters for the whole household',
            ].map((line) => (
              <li key={line} className="flex gap-3">
                <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" /> {line}
              </li>
            ))}
          </ul>
        </div>
      </section>
      <section className="py-16 bg-[#EDF7F6] dark:bg-[#99E1D9]/5 px-4">
        <div className="max-w-5xl mx-auto grid sm:grid-cols-3 gap-8 text-center">
          {[
            { n: userCount == null ? '—' : userCount.toLocaleString(), l: 'Active users' },
            { n: '24/7', l: 'Pay anytime' },
            { n: '30s', l: 'Typical token time' },
          ].map((s) => (
            <div key={s.l}>
              <p className="text-4xl font-extrabold text-primary">{s.n}</p>
              <p className="text-muted-foreground mt-1">{s.l}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="py-20 px-4 text-center">
        <Heart className="w-10 h-10 text-primary mx-auto mb-4" />
        <h2 className="text-2xl font-extrabold mb-3">Come as a customer. Stay as family.</h2>
        <button
          onClick={() => navigate('/register')}
          className="mt-4 px-6 py-3 bg-primary text-primary-foreground rounded-xl font-semibold"
        >
          Join free
        </button>
      </section>
    </MarketingLayout>
  );
}
